module.exports = __webpack_public_path__ + "img/banner2.13ce5fbf.png";